import {AuthPiece} from 'aws-amplify-react';
import request from "superagent";
import APP_ENV from "../Environment";
import React from "react";
import {CheckEccAccountComponents} from "../Components/CheckEccAccountComponents";

export default class CheckEccAccount extends AuthPiece {
    constructor(props) {
        super(props);

        this.checkAccountInEcc = this.checkAccountInEcc.bind(this);

        this._validAuthStates = ['checkEccAccount'];
        this.state = {};
    }
    componentDidUpdate() {
        window.scrollTo(0, 0);
    }
    checkAccountInEcc() {
        const isEmptyInput = (nickname, password) => {
            let err = "";
            err += !nickname ? "ログインID " : "";
            err += !password ? "パスワード " : "";
            if (err !== '') {
                err += 'が未入力です';
            }
            return err;
        };

        const { nickname, password } = this.inputs;
        const err = isEmptyInput(nickname, password);
        if (err !== '') {
            this.error(err);
            return;
        }

        this.migrateEccUser(nickname, password)
    }

    migrateEccUser = (nickname, password) => {
        let putData = 
        {
          "nickname": nickname,
          "password": password
        }

        request
            .put(APP_ENV.BFF + '/user/account')
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .send(putData)
            .end((err, res) => {
                if (err) {
                    console.log("通信エラー",err);
                    this.error("ユーザ情報の取得に失敗しました");
                } else {
                    window.history.replaceState('','','/confirm_update_account');
                    this.sendConfirmEccAcount(res);
                }
            });
    };

    sendConfirmEccAcount(res) {
        const email = res.body.email;
        const customer_id = res.body.customer_id;
        this.changeState('confirmUpdateEccAccount', {email, customer_id});
    }

    showComponent(theme) {
        return (
            <CheckEccAccountComponents theme={theme} checkEccAccount={this}
                                      checkAccountInEcc={this.checkAccountInEcc}
                                      changeStateFunc={() => {
                                          window.history.replaceState('','','/');
                                          this.changeState('signIn')
                                      }}/>
        );
    }
}